'use strict';

export default class PopupOverlay {
  constructor($selector, selfInit = true) {
    this.$selector = $selector;

    if(selfInit) this.init();
  }

  init() {
    setTimeout(() => {
      this.$selector.addClass('active');
      $("body").addClass("no-scroll");
    }, 3000);

    $('button', this.$selector).on('click', (e) => {
      e.preventDefault();

      $("body").removeClass("no-scroll");
      this.$selector.remove();
    });
  }
}
